'use strict';

import 'glob:./polyfills/**/*';



// WEBPACK FOOTER //
// ./bluemountain/assets/scripts/vendor/fabrique/base.js